'use strict';
// Native bundle variants own prices, four exact components and shared inventory in Shopify.
// The browser never sets a merchandise price or deducts inventory itself.
window.adventCheckout = async function (items, giftCard) {
  if (window.ADVENT_CHECKOUT_READY !== true) throw new Error('Der Verkauf ist noch nicht geöffnet.');
  if (window.ADVENT_MARKET?.country !== 'DE' || window.ADVENT_MARKET?.currency !== 'EUR') {
    throw new Error('Dieser Kalender ist nur im deutschen Shop in EUR erhältlich.');
  }
  if (!Array.isArray(items) || !items.length || giftCard) throw new Error('Bitte prüfe deinen Warenkorb.');
  const map = window.ADVENT_BUNDLES;
  const lines = await Promise.all(items.map(async item => {
    if (!Array.isArray(item.items) || item.items.length !== 4 || !Number.isSafeInteger(item.qty) || item.qty < 1 || typeof item.group !== 'string' || !item.group) {
      throw new Error('Bitte wähle genau vier Schmuckstücke.');
    }
    const pieces = item.items.map(get);
    if (pieces.some(p => !p || p.needsSize || p.available !== true) || new Set(pieces.map(p => p.family)).size !== 4) {
      throw new Error('Bitte prüfe Verfügbarkeit und Länge deiner vier Schmuckstücke.');
    }
    const key = pieces.map(p => p.variantId).sort().join(',');
    let id;
    if (item.type === 'build') {
      if (!window.AdventBuilderPricing || !window.ADVENT_BUILD_INDEX) throw new Error('Der Kalenderpreis konnte nicht geladen werden. Bitte versuche es erneut.');
      let verified;
      try { verified = await window.AdventBuilderPricing.resolve(pieces, 'DE', {fresh:true}); }
      catch (_) { throw new Error('Der Kalenderpreis konnte nicht bestätigt werden. Lade die Seite neu und wähle erneut.'); }
      if (Math.round(Number(item.price) * 100) !== verified.cents) throw new Error('Der Kalenderpreis hat sich geändert. Lade die Seite neu und wähle erneut.');
      id = verified.variantId;
    } else id = map.fixed[item.type]?.key === key ? map.fixed[item.type].variantId : null;
    if (!id) throw new Error('Diese Kombination ist noch nicht verfügbar. Bitte wähle erneut.');
    return {
      id, quantity: item.qty,
      properties: {
        _advent_2026: 'true', _advent_group: item.group,
        ...Object.fromEntries(Object.entries(window.AdventAttribution?.properties?.() || {}).map(([key,value]) => ['_'+key,value])),
        Kalender: labels[item.type],
        Verpackung: '4 schwarze Schmuckboxen mit Schleifen · Unterseite 1–4',
        ...Object.fromEntries(pieces.map((p, i) => ['Advent ' + (i + 1), p.name + ' · ' + p.sku + (p.baseId ? ' · ' + p.size : '')]))
      }
    };
  }));
  const cartResponse = await fetch('/cart.js', {headers: {Accept: 'application/json'}});
  if (!cartResponse.ok) throw new Error('Der Warenkorb ist gerade nicht erreichbar. Bitte versuche es erneut.');
  const current = await cartResponse.json();
  // Retrying after a lost response must not add the same calendar twice.
  const updates = {};
  // The custom drawer is authoritative for Advent lines; ordinary shop items stay untouched.
  // This also reconciles a calendar removed after returning from checkout.
  for (const existing of current.items) {
    if (existing.properties?._advent_2026 === 'true' && existing.properties?._advent_group &&
        !lines.some(line => String(existing.variant_id) === String(line.id) && existing.properties._advent_group === line.properties._advent_group)) {
      updates[existing.key] = 0;
    }
  }
  const missing = lines.filter(line => {
    const existing = current.items.find(existing => String(existing.variant_id) === String(line.id) && existing.properties?._advent_group === line.properties._advent_group);
    if (existing && existing.quantity !== line.quantity) updates[existing.key] = line.quantity;
    return !existing;
  });
  if (missing.length) {
    const response = await fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: missing})
    });
    if (!response.ok) {
      if (response.status === 422) throw new Error('Mindestens ein Schmuckstück ist nicht mehr in der gewünschten Menge verfügbar. Bitte passe deine Auswahl an.');
      throw new Error('Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
    }
  }
  // Order attributes expose the packing requirement without replacing the customer's note.
  const marked = await fetch('/cart/update.js', {
    method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({updates, attributes: {Adventskalender: '2026', ...window.AdventAttribution?.properties?.(), 'Advent pakning': '4 smykkeæsker med sorte bånd pr. kalender. Nummerér under bunden 1–4 efter Advent-felterne på kalenderlinjen.'}})
  });
  if (!marked.ok) throw new Error('Dein Kalender liegt im Warenkorb. Die Verpackungsangabe konnte noch nicht gespeichert werden – bitte erneut versuchen.');
  location.assign('/checkout');
};
